import { render, staticRenderFns } from "./UsersCardLeftPanelUsers.vue?vue&type=template&id=523887be&"
import script from "./UsersCardLeftPanelUsers.vue?vue&type=script&lang=ts&"
export * from "./UsersCardLeftPanelUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports